import Vue from 'vue';
import Router from 'vue-router';

import newportal from '../components/newportal';

import InsuranceFlow from '@/components/insurance/InsuranceFlow.vue';
import { insuranceSubRoutes } from '@/components/insurance/routes';

// Top-level insurance auth routes (legacy names used by components)
const insuranceAuthRoutes = [
	{
		path: '/insurance/auth',
		name: 'Auth',
		component: () => import('@/components/insurance/Auth/AuthCard.vue'),
		meta: { title: 'Auth' },
	},
	{
		path: '/insurance/otp',
		name: 'Otp_Verification',
		component: () =>
			import('@/components/insurance/Auth/OTPVerification.vue'),
		meta: { title: 'Otp Verification' },
	},
	{
		path: '/insurance/setpassword',
		name: 'Set_Password',
		component: () => import('@/components/insurance/Auth/SetPassword.vue'),
		meta: { title: 'Set Password' },
	},
	{
		path: '/insurance/resetpassword',
		name: 'RESET_Password',
		component: () =>
			import('@/components/insurance/Auth/ResetPassword.vue'),
		meta: { title: 'Reset Password' },
	},
];

let routes = [
	{
		path: '/radio-test',
		name: 'RadioTest',
		component: () => import(`@/components/main/radio-test`),
	},
	{
		path: '/',
		component: () => import('@/components/main/construction'),
	},
	// {
	//   path: '/main/',
	//   component: () => import('@/components/layout'),
	//   children: [
	//     ...MainComponents.subRoutes.main,
	//     ...SetUpComponents.subRoutes.main,
	//     ...AuthComponents.subRoutes.main
	//   ]
	// },
	{
		path: '/insurance',
		component: () => import('@/components/layout'),
		name: 'Insurance',
		children: [
			{
				path: '',
				component: InsuranceFlow,
			},
			...insuranceSubRoutes,
		],
	},
];

// Append the top-level auth routes so they are available outside the insurance layout
routes = [...routes, ...insuranceAuthRoutes];

importComponents([newportal]);
Vue.use(Router);

export default new Router({
	mode: 'history',
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			// restore scroll on back/forward
			return savedPosition;
		} else {
			// always scroll to top on new navigation
			return { x: 0, y: 0 };
		}
	},
});

function importComponents(services) {
	for (let i = 0; i < services.length; i++) {
		let service = services[i];
		routes = [...routes, ...service.routes];
	}
}
